import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';
import type { AppRole } from './types';

export function ProtectedRoute({
  children,
  roles,
}: {
  children: ReactNode;
  roles?: AppRole[];
}) {
  const { user, loading, error, retry } = useAuth();
  const location = useLocation();

  if (loading)
    return <div className="route-loading">Preverjanje prijave …</div>;
  if (error)
    return (
      <main className="route-loading route-loading--error" role="alert">
        <p>{error}</p>
        <button className="secondary-button" type="button" onClick={retry}>
          Poskusi znova
        </button>
      </main>
    );
  if (!user)
    return (
      <Navigate to="/prijava" state={{ from: location.pathname }} replace />
    );
  if (roles && !roles.includes(user.role))
    return <Navigate to="/izdelki" replace />;
  return children;
}
